// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3NuMk","slideWrapper":"_27N_n"};